import CLink from "components/CLink";
import color from "context/MaterialUITheme/color";

const CFaqsButton: React.FC<{ pathname?: string }> = ({ pathname }) => {
  const isSelected = pathname === "/faqs";
  return (
    <CLink
      to="/faqs"
      sx={{
        fontSize: { md: "1.4rem", xs: "2.4rem" },
        color: {
          md: isSelected ? color.primary : color.black,
          xs: color.white,
        },
      }}
    >
      FAQs
    </CLink>
  );
};

export default CFaqsButton;
